import { useEffect } from "react";

import {
  consumeTelegramConnectionCallback,
  trackNotificationChannelEnabled,
} from "@/lib/analytics";

/** Records the completed connection only after Telegram permission is verified. */
export function useConsumeTelegramConnectionCallback(
  connectionConfirmed: boolean,
  userId: string | null,
) {
  useEffect(() => {
    if (!connectionConfirmed || !userId) return;
    consumeTelegramConnectionCallback();
    trackNotificationChannelEnabled("telegram", "connection_callback");
  }, [connectionConfirmed, userId]);
}
